// Stable cross-pane hover ID. The same listing should resolve to the same
// hoverId whether ResultsPane is asking (for a card) or MapPane is asking
// (for a marker). Don't include array index — that's a React-key concern,
// not a hover-correlation concern. If the API returns duplicates of the
// same wiggot_code, hovering one card lights up every matching marker too,
// which is the right behavior at the listing level.

export const hoverIdForDev = (dev) =>
    `dev-${dev?.id || dev?.wiggot_code || dev?.development_id || "x"}`;

export const hoverIdForProp = (prop) =>
    `prop-${prop?.wiggot_code || prop?.id || prop?.property_id || "x"}`;

export const buildHoverId = (entry) => {
    if (!entry) return null;
    return entry.kind === "development" ? hoverIdForDev(entry.data) : hoverIdForProp(entry.data);
};
